import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import EnquiresHome from "./components/EnquiresHome";

const Enquires = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Enquires" />
        {/* Table structure for jQuery DataTable */}
        <DatatableSection>
          <EnquiresHome />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default Enquires;
